import { GetFeaturedProducts, UpdateFeaturedProducts, DeactivateFeaturedProduct } from '../../../../../actions/FeaturedProductActions';
import { GET_ERRORS, UPDATE_FEATURED_PRODUCTS, DEACTIVATE_FEATURED_PRODUCTS } from "../../../../../actions/types";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { getAllProducts } from '../../../../../actions/ProductActions';
import noAvailable from "../../../../../img/noAvailable.png";
import AddFeaturedProducts from './AddFeaturedProduct';
import LoadingOverlay from 'react-loading-overlay';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import docs from "../../../../../config/docs";
import { Info } from "@material-ui/icons";
import React, { Component } from 'react';
import { IconButton } from "material-ui";
import { connect } from "react-redux";
import './FeaturedProduct.scss';
const URL = docs.docsFeaturedProducts;

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}


class FeaturedProducts extends Component {

	///---------------------------------------INIT-------------------------------------

	state = {
		isVisible: true,
		featuredProducts: [],
		activeLoader: true,
		showSnackBar: false,
		textSnackBar: '',
		severitySnackBar: 'success',
	};

	constructor() {
		super();
		this.changePosition = this.changePosition.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}

	componentDidMount() {
		this.props.GetFeaturedProducts();
		this.props.getAllProducts();
	}

	componentDidUpdate(prevProps) {

		if (this.state.featuredProducts !== this.props.featuredProducts) {
			this.setState({
				featuredProducts: this.props.featuredProducts,
				activeLoader: false
			})
		}
		else if (this.props.actionType === DEACTIVATE_FEATURED_PRODUCTS && prevProps.actionType !== DEACTIVATE_FEATURED_PRODUCTS) {
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Se ha desactivado el producto exitosamente.",
				severitySnackBar: 'success',
			}, () => {
				this.props.GetFeaturedProducts();
			});
		}
		else if (this.props.actionType === UPDATE_FEATURED_PRODUCTS && prevProps.actionType !== UPDATE_FEATURED_PRODUCTS) {
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Producto agregado exitosamente.",
				severitySnackBar: 'success',
			}, () => {
				this.props.GetFeaturedProducts();
			});
		}
		else if (this.props.actionType === GET_ERRORS && prevProps.actionType !== GET_ERRORS) {
			this.setState({
				showSnackBar: true,
				textSnackBar: this.props.error,
				severitySnackBar: 'error',
			});
		}
	}

	///---------------------------------------EVENTS-------------------------------------

	setDefault(e) {
		e.target.src = noAvailable
	}

	changePosition(result) {
		const { destination, source } = result;
		if (!destination) {
			return
		};
		if (
			destination.droppableId === source.droppableId &&
			destination.index === source.index
		) {
			return;
		}


		const newData = Array.from(this.state.featuredProducts);

		const [removed] = newData.splice(source.index, 1);
		newData.splice(destination.index, 0, removed);
		this.setState({
			featuredProducts: newData,
			activeLoader: true
		}, () => {
			this.props.UpdateFeaturedProducts(newData);
		});

	}

	handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		this.setState({
			showSnackBar: false
		})
	};

	addFeaturedProduct = (product) => {
		this.setState({
			activeLoader: true,
			isVisible: false
		})
		product.descripcion = product.descripcion.split("] ");
		product.descripcion = product.descripcion[1];
		let productToAdd = [
			{
				no_sap: product.sku,
				description: product.descripcion,
			}
		]

		this.props.UpdateFeaturedProducts(productToAdd);
	}

	deactiveFeaturedProduct = (row) => {
		this.setState({
			activeLoader: true
		}, () => this.props.DeactivateFeaturedProduct(row))
	}

	redirectTo() {
		const newWindow = window.open(URL, '_blank', 'noopener,noreferrer')
		if (newWindow) newWindow.opener = null
	}

	actions(row) {
		return (
			<button
				onClick={() => this.deactiveFeaturedProduct(row)}
				key={row._id}
				className="buttonDelete"
			>
				Eliminar
			</button>
		)
	}

	getImage(sku) {
		let image = "https://d1it31htfvjlm3.cloudfront.net/300x300/" + sku + "_01.png"
		return (
			<img src={image}
				width="80"
				style={{ objectFit: "cover" }}
				alt={sku}
				onError={this.setDefault}
				id={image} />
		)
	}

	draggableTable() {
		return (
			<DragDropContext onDragEnd={this.changePosition}>
				<table className="tableFeatured">
					<thead>
						<tr className="title-table">
							<th className="index">Posición</th>
							<th>Articulo</th>
							<th>Descripción</th>
							<th>Imagen</th>
							<th>Acciones</th>
						</tr>
					</thead>


					<Droppable droppableId="droppable">
						{(droppableProvided) =>
						(
							<tbody
								{...droppableProvided.droppableProps}
								ref={droppableProvided.innerRef}
							>
								{this.state.featuredProducts.map((item, index) => {
									return (
										<Draggable key={item.no_sap} draggableId={item.no_sap} index={index}>
											{
												(draggableProvided) => (
													<tr
														className="custom-row-table"
														{...draggableProvided.draggableProps}
														ref={draggableProvided.innerRef}
														{...draggableProvided.dragHandleProps}
														key={index}>
														<td className="index">{index + 1}</td>
														<td>{item.no_sap}</td>
														<td>{item.description}</td>
														<td>{this.getImage(item.no_sap)}</td>
														<td>{this.actions(item)}</td>
													</tr>
												)
											}
										</Draggable>
									)
								})}
								{droppableProvided.placeholder}
							</tbody>
						)}
					</Droppable>

				</table>
			</DragDropContext>
		)
	}

	///---------------------------------------VIEW-------------------------------------
	render() {
		let products = [];
		if (this.props.product_reducer.allProducts)
			products = this.props.product_reducer.allProducts.productos;
		return (

			<div className="main-content" style={{ "minHeight": "500px" }}>
				<div className="malls-category-headers">
					Productos destacados
					<IconButton
						size="small"
					>
						<Info onClick={() => this.redirectTo()} />
					</IconButton>
				</div>
				<AddFeaturedProducts
					isVisible={this.state.isVisible}
					addFeaturedProduct={this.addFeaturedProduct}
					products={products}
				/>
				<div className="user-category-wrapper">
					{
						this.draggableTable()
					}
				</div>
				<LoadingOverlay
					active={this.state.activeLoader}
					isVisible={this.state.activeLoader}
					spinner
					text='Esto puede tardar unos minutos'
					styles={{
						wrapper: {
							width: this.state.activeLoader ? '100%' : '0%',
							height: this.state.activeLoader ? '100%' : '0%',
							overflow: 'hidden',
						},
						overlay: (base) => ({
							...base,
							background: 'rgba(10, 10, 10, 0.7)'
						})
					}}>
				</LoadingOverlay>
				{
					<Snackbar open={this.state.showSnackBar} autoHideDuration={6000} onClose={this.handleClose}>
						<Alert onClose={this.handleClose} severity={this.state.severitySnackBar}>
							{this.state.textSnackBar}
						</Alert>
					</Snackbar>
				}
			</div>

		);
	}
}

const mapStateToProps = state => ({
	product_reducer: state.product_reducer,
	featuredProducts: state.featured_product_reducer.featuredProducts,
	actionType: state.featured_product_reducer.actionType,
	error: state.featured_product_reducer.error
});

export default connect(
	mapStateToProps,
	{
		GetFeaturedProducts,
		getAllProducts,
		UpdateFeaturedProducts,
		DeactivateFeaturedProduct
	}
)(FeaturedProducts);